import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';

import { SidebarMenuButton } from '@/components/ui/sidebar';

import { useTheme } from '@/providers';

export const SidebarThemeItem = () => {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const isDark = theme === 'dark';
  const currentLabel = t(isDark ? 'Dark theme' : 'Light theme');

  return (
    <SidebarMenuButton
      tooltip={`${t('Theme')}: ${currentLabel}`}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      {isDark ? <Moon /> : <Sun />}
      <span>{t('Theme')}</span>
      <span className="ml-auto text-xs">{currentLabel}</span>
    </SidebarMenuButton>
  );
};
